import { Country, State } from "country-state-city";

export interface StateDetails {
  stateCode: string;
  stateName: string;
  countryName: string;
  countryCode: string | null;
}

export function getStateDetails(stateCode: string): StateDetails {
  const countryCode = "US";
  const countryName = "United States";
  
  const states = State.getStatesOfCountry(countryCode);
  const match = states.find((s) => s.isoCode === stateCode);

  if (match) {
    return {
      stateCode,
      stateName: match.name,
      countryName,
      countryCode,
    };
  }

  return {
    stateCode,
    stateName: "Unknown",
    countryName,
    countryCode: null,
  };
}
